import React from 'react';
import { Navigate, Route } from 'react-router-dom';

import DNPrintTemplate from 'pages/delivery-note/dn-detail/print-components/DNPrintTemplate';
import InvoicePackPrintTemplate from 'pages/pack/pack-print-page/print-components/invoice-pack-print-template/InvoicePackPrintTemplate';
import InvoiceSPPrintTemplate from 'pages/pack/pack-print-page/print-components/invoice-sp-template/InvoiceSPPrintTemplate';
import InvoicePrintTemplate from 'pages/pack/pack-print-page/print-components/invoice-template/InvoicePrintTemplate';
import ShippingLabelPrintTemplate from 'pages/pack/pack-print-page/print-components/ship-label-template/ShippingLabelPrintTemplate';
import TTFPrintTemplate from 'pages/pack/pack-print-page/print-components/ttf-template/TTFPrintTemplate';

import {
  OUTBOUND_PRINT_TEMPLATE_ROUTE_ROOT,
  OUTBOUND_PRINT_TEMPLATE_ROUTES,
} from './constants';

export const usePrintTemplateRouter = (): React.JSX.Element => (
  <Route path={OUTBOUND_PRINT_TEMPLATE_ROUTE_ROOT}>
    <Route
      path={OUTBOUND_PRINT_TEMPLATE_ROUTES.INVOICE}
      element={<InvoicePrintTemplate />}
    />
    <Route
      path={OUTBOUND_PRINT_TEMPLATE_ROUTES.INVOICE_PACK}
      element={<InvoicePackPrintTemplate />}
    />
    <Route
      path={OUTBOUND_PRINT_TEMPLATE_ROUTES.INVOICE_ESP}
      element={<InvoiceSPPrintTemplate />}
    />
    <Route
      path={OUTBOUND_PRINT_TEMPLATE_ROUTES.TTF}
      element={<TTFPrintTemplate />}
    />
    <Route
      path={OUTBOUND_PRINT_TEMPLATE_ROUTES.SHIP_LABEL}
      element={<ShippingLabelPrintTemplate />}
    />
    <Route
      path={OUTBOUND_PRINT_TEMPLATE_ROUTES.DELIVERY_NOTE}
      element={<DNPrintTemplate />}
    />
    <Route
      path={OUTBOUND_PRINT_TEMPLATE_ROUTES.WILDCARD}
      element={<Navigate to="/" />}
    />
  </Route>
);
